import React from "react";
import { MdClose } from "react-icons/md";
import ScrollOff from "../../components/pageComponents/WindowScrollOff/ScrollOff";
function ImageModel({ image, setModelClick, message }) {
  const handleClick = () => {
    setTimeout(() => {
      setModelClick(false);
    }, 0);
  };

  return (
    <ScrollOff message={message}>
      <div
        onClick={() => handleClick()}
        className="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-black/60 backdrop-blur-sm"
      >
        <div className="flex w-full justify-center p-4">
          <div
            className="w-11/12 laptop:w-2/3 max-h-[90vh] rounded-xl overflow-hidden bg-white shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              alt="Document preview"
              src={image}
              width={100}
              height={100}
              className="w-full h-full object-contain max-h-[80vh]"
            />
          </div>
          <button
            className="absolute top-4 right-4 p-2 bg-white/90 hover:bg-white text-gray-700 rounded-full shadow-lg transition-colors z-10"
            onClick={() => handleClick()}
          >
            <MdClose className="w-6 h-6" />
          </button>
        </div>
      </div>
    </ScrollOff>
  );
}

export default ImageModel;
